<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>JoAnn Aitken has lived all her life in Hamilton, Ontario. She worked for many years at a local community college and has always enjoyed travel. A 2015 trip to Ireland brought together some ideas which became <em>Family Portraits</em>. She describes writing the book as “easy” once she got started. As the end of the story approached, she found it hard to let go. She hopes her readers will feel the same.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7769f39a